module.exports = __webpack_public_path__ + "static/media/true.41838418.png";